export default __webpack_public_path__ + "static/advice-bg-45b9afeeb0361fb70bd01226eb4ce0ba.png";